import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HowItWorks from "../pages/how-it-works/page";
import Properties from "../pages/properties/page";
import PropertyDetail from "../pages/property-detail/page";
import Regions from "../pages/regions/page";
import Honesty from "../pages/honesty/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import CoOwnership from "../pages/co-ownership/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/properties/:id",
    element: <PropertyDetail />,
  },
  {
    path: "/co-ownership",
    element: <CoOwnership />,
  },
  {
    path: "/how-it-works",
    element: <HowItWorks />,
  },
  {
    path: "/properties",
    element: <Properties />,
  },
  {
    path: "/regions",
    element: <Regions />,
  },
  {
    path: "/honesty",
    element: <Honesty />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;